import { z } from 'zod';

export const $CandidateDecisionType = z.enum([
  'WAITING',
  'DECLINED',
  'POSITIVE',
  'NEGATIVE',
  'PENDING',
]);
